import Choices from "choices.js";
import { isAdmin } from "kwp-core/scripts/utils/helpers";

export default () => {
    function isAriaExpanded(el) {
        return el.getAttribute("aria-expanded");
    }

    if (isAdmin()) return;

    const selectFields = document.querySelectorAll("select");
    selectFields.forEach((select) => {
        new Choices(select, {
            searchEnabled: false,
            removeItemButton: true,
            renderSelectedChoices: "always",
            shouldSort: false,
        });

        if (select.hasAttribute("multiple")) {
            const choicesWrapper = select.closest(".choices");
            const choicesInner =
                choicesWrapper.querySelector(".choices__inner");
            const searchInput =
                choicesWrapper.querySelector("input[type='text']");
            const choicesList = choicesWrapper.querySelector(
                ".choices__list--dropdown"
            );
            searchInput.setAttribute("readonly", "readonly");

            select.addEventListener("change", (e) => {
                if (e.currentTarget.selectedOptions.length) {
                    searchInput.style.display = "none";
                } else {
                    searchInput.style.display = "unset";
                }
            });

            // choicesInner.addEventListener("click", (e) => {
            //     if (e.target === choicesInner || e.target === searchInput) {
            //         choicesWrapper.setAttribute(
            //             "aria-expanded",
            //             !isAriaExpanded(choicesWrapper)
            //         );
            //         choicesList.setAttribute(
            //             "aria-expanded",
            //             !isAriaExpanded(choicesList)
            //         );
            //         choicesWrapper.classList.toggle("is-open");
            //         choicesWrapper.classList.toggle("is-focused");
            //         choicesList.classList.toggle("is-active");
            //     }
            // });
        }
    });
};
